import { Injectable } from '@angular/core';
import { TagState } from 'src/app/_model/tag-state';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { TagStatesService } from '../../logic/tag-states.service';
import { TagStatesDaoService } from '../tag-states-dao.service';

@Injectable()
export class TagStatesStorageDaoService implements TagStatesDaoService {
    constructor(
        private logger: LoggingService,
        private keyValueService: KeyValuePersistenceService
    ) { }

    async loadLocalTagStates(): Promise<TagState[]> {
        return await this.keyValueService.load(TagStatesService.PERSISTED_TAG_STATES);
    }

    async persistLocalTagStates(tagStates: TagState[]): Promise<void> {
        await this.keyValueService.store(TagStatesService.PERSISTED_TAG_STATES, tagStates);
    }
}